import clsx from 'clsx';
import { ComponentPropsWithoutRef } from 'react';

interface RadioInputProps extends Omit<
  ComponentPropsWithoutRef<'input'>,
  'type'
> {
  error: boolean;
}

const baseClasses =
  'appearance-none w-8 h-8 rounded-full cursor-pointer bg-white ' +
  'border-[0.5px] ' +
  'checked:bg-scale-green checked:border-0 ' +
  'focus:outline focus:outline-1 focus:outline-scale-green focus:outline-offset-[3px]';

export function RadioInput({ error, className, ...rest }: RadioInputProps) {
  return (
    <input
      type="radio"
      className={clsx(
        baseClasses,
        error ? 'border-scale-red' : 'border-black',
        className
      )}
      {...rest}
    />
  );
}
